import { render, staticRenderFns } from "./GroupWeighingPanel.vue?vue&type=template&id=dc4deb26&scoped=true"
import script from "./GroupWeighingPanel.vue?vue&type=script&lang=js"
export * from "./GroupWeighingPanel.vue?vue&type=script&lang=js"
import style0 from "./GroupWeighingPanel.vue?vue&type=style&index=0&id=dc4deb26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4deb26",
  null
  
)

export default component.exports